import React from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText'
import { fileDownload } from '../../../../util/getAuditTrailData'

const DataExport = ({data}) => {
    
  return <>
    <HeadingText heading="Associated Version" text={data.version_id}/>
    <HeadingText heading="Activity" text={data.action}>
    &nbsp;&nbsp;<button className="btn-outline-primary" onClick={()=>{
          fileDownload(data.version_content.file_name)
        }}>Download the Exported Document(s)</button>
    </HeadingText>
  </>
}

export default DataExport